import React from 'react';
import { Search, Sparkles, Bell, User } from 'lucide-react';
import StatsPanel from './components/StatsPanel';
import ProjectsPanel from './components/ProjectsPanel';
import TaskPanel from './components/TaskPanel';
import UserSummary from './components/UserSummary';
import './landingPage.css';

const LandingPage = () => {
  const handleSearch = (query) => {
    console.log('Searching for:', query);
    // Implement search logic
  };

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="landing-header">
        <div className="header-left">
          <div className="logo">
            <span className="logo-icon">R</span>
            <span className="logo-text">Frontera</span>
          </div>
          <div className="search-bar pill">
            <Search className="search-icon" size={18} />
            <input
              type="text"
              placeholder="Search for a project..."
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
        </div>
        <div className="header-actions">
          <button className="action-btn quests-btn pill-dark">
            <Sparkles size={18} />
            <span>Quests</span>
          </button>
          <button className="action-btn icon-btn pill">
            <Bell size={20} />
          </button>
          <div className="profile pill">
            <User size={18} className="avatar" />
            <span className="profile-name">Claire Yee</span>
          </div>
        </div>
      </header>

      {/* Main Grid */}
      <main className="landing-main">
        <div className="dashboard-grid three-col">
          <div className="left-stack">
            <StatsPanel />
            <ProjectsPanel />
          </div>
          <TaskPanel />
          <UserSummary />
        </div>
      </main>
    </div>
  );
};

export default LandingPage;
